module.exports = __webpack_public_path__ + "img/huawei-store.8cfa6f7d.png";